module.exports = window["core-js/modules/es.array.map.js"];